import { CA } from '../analytics/Analytics.ts';
import { AnalyticEventCategory } from '../../../../shared/entity_datas/EntityDatas.ts';
import { GameAction } from '@colonist/game-base-types';
import { ClientMessageSubType } from '@colonist/types';
export class SocketGameSend {
    // ====================================================================================================================================
    // Game - Trade
    // ====================================================================================================================================
    createTrade(offer) {
        this.send(GameAction.CreateTrade, offer);
    }
    executeTrade(offerId, playerColor) {
        const dataToSend = {
            tradeId: offerId,
            playerToExecuteTradeWith: playerColor
        };
        this.send(GameAction.ExecuteTrade, dataToSend);
    }
    updateTradeResponse(tradeResponse) {
        this.send(GameAction.UpdateTradeResponse, tradeResponse);
    }
    toggleEmbargoAgainstPlayer(targetPlayer) {
        this.send(GameAction.ToggledEmbargo, targetPlayer);
    }
    // ====================================================================================================================================
    // Game - General
    // ====================================================================================================================================
    clickedPassTurn() {
        this.send(GameAction.PassedTurn, true);
    }
    clickedDice() {
        this.send(GameAction.ClickedDice, true);
    }
    selectedTile(tileIndex) {
        this.send(GameAction.SelectedTile, tileIndex);
    }
    selectedTiles(tileIndexes) {
        this.send(GameAction.SelectedTiles, tileIndexes);
    }
    selectCards(resourcesToSend) {
        this.send(GameAction.SelectedCards, resourcesToSend);
    }
    selectCardsState(resourcesToSend) {
        this.send(GameAction.SelectedCardsState, resourcesToSend);
    }
    selectPlayer(playerColor) {
        this.send(GameAction.SelectedPlayer, playerColor);
    }
    selectedInitialPlacementIndex(placementIndex) {
        this.send(GameAction.SelectedInitialPlacementIndex, placementIndex);
    }
    buyDevCard() {
        this.send(GameAction.BuyDevelopmentCard, true);
    }
    buildRoad() {
        this.send(GameAction.WantToBuildRoad, true);
    }
    buildSettlement() {
        this.send(GameAction.WantToBuildSettlement, true);
    }
    buildCity() {
        this.send(GameAction.WantToBuildCity, true);
    }
    buildShip() {
        this.send(GameAction.WantToBuildShip, true);
    }
    moveShip() {
        this.send(GameAction.WantToMoveShip, true);
    }
    buildCityWall() {
        this.send(GameAction.WantToBuildCityWall, true);
    }
    placeKnight() {
        this.send(GameAction.WantToPlaceKnight, true);
    }
    upgradeKnight() {
        this.send(GameAction.WantToUpgradeKnight, true);
    }
    activateKnight() {
        this.send(GameAction.WantToActivateKnight, true);
    }
    takeKnightAction() {
        this.send(GameAction.WantToTakeKnightAction, true);
    }
    confirmBuildRoad(edgeTileNo) {
        this.send(GameAction.ConfirmBuildRoad, edgeTileNo);
    }
    confirmBuildRoadSkippingSelection(edgeTileNo) {
        this.send(GameAction.ConfirmBuildRoadSkippingSelection, edgeTileNo);
    }
    confirmBuildSettlement(cornerTileNo) {
        this.send(GameAction.ConfirmBuildSettlement, cornerTileNo);
    }
    confirmBuildSettlementSkippingSelection(edgeTileNo) {
        this.send(GameAction.ConfirmBuildSettlementSkippingSelection, edgeTileNo);
    }
    confirmBuildCity(cornerTileNo) {
        this.send(GameAction.ConfirmBuildCity, cornerTileNo);
    }
    confirmBuildCitySkippingSelection(edgeTileNo) {
        this.send(GameAction.ConfirmBuildCitySkippingSelection, edgeTileNo);
    }
    confirmBuildShip(edgeTileNo) {
        this.send(GameAction.ConfirmBuildShip, edgeTileNo);
    }
    confirmBuildShipSkippingSelection(edgeTileNo) {
        this.send(GameAction.ConfirmBuildShipSkippingSelection, edgeTileNo);
    }
    selectedShipToMove(edgeTileNo) {
        this.send(GameAction.SelectedShipToMove, edgeTileNo);
    }
    confirmMoveShip(edgeTileNo) {
        this.send(GameAction.ConfirmMoveShip, edgeTileNo);
    }
    confirmRemoveRoad(edgeTileNo) {
        this.send(GameAction.ConfirmRemoveRoad, edgeTileNo);
    }
    confirmBuildCityWall(cornerTileNo) {
        this.send(GameAction.ConfirmBuildCityWall, cornerTileNo);
    }
    confirmBuildCityWallSkippingSelection(cornerTileNo) {
        this.send(GameAction.ConfirmBuildCityWallSkippingSelection, cornerTileNo);
    }
    confirmPlaceKnight(cornerTileNo) {
        this.send(GameAction.ConfirmPlaceKnight, cornerTileNo);
    }
    confirmPlaceKnightSkippingSelection(cornerTileNo) {
        this.send(GameAction.ConfirmPlaceKnightSkippingSelection, cornerTileNo);
    }
    confirmUpgradeKnight(cornerTileNo) {
        this.send(GameAction.ConfirmUpgradeKnight, cornerTileNo);
    }
    confirmUpgradeKnightSkippingSelection(cornerTileNo) {
        this.send(GameAction.ConfirmUpgradeKnightSkippingSelection, cornerTileNo);
    }
    confirmActivateKnight(cornerTileNo) {
        this.send(GameAction.ConfirmActivateKnight, cornerTileNo);
    }
    confirmActivateKnightSkippingSelection(cornerTileNo) {
        this.send(GameAction.ConfirmActivateKnightSkippingSelection, cornerTileNo);
    }
    // eslint-disable-next-line class-methods-use-this
    async sendGameAnalyticOnce(type, value) {
        const eventData = {
            type: type,
            category: AnalyticEventCategory.Game,
            floatValue: value
        };
        await CA.sendAnalyticEventOnce(eventData);
    }
    confirmCityUpgrade(cityImprovementType) {
        this.send(GameAction.ConfirmCityUpgrade, cityImprovementType);
    }
    confirmPlaceMetropolis(cornerTileNo) {
        this.send(GameAction.ConfirmBuildMetropolis, cornerTileNo);
    }
    confirmPillageCity(cornerTileNo) {
        this.send(GameAction.ConfirmPillageCity, cornerTileNo);
    }
    confirmSelectKnightToTakeAction(cornerTileNo) {
        this.send(GameAction.SelectKnightToTakeAction, cornerTileNo);
    }
    confirmMoveKnight(cornerTileNo) {
        this.send(GameAction.ConfirmMoveKnight, cornerTileNo);
    }
    confirmMoveKnightOffTurn(cornerTileNo) {
        this.send(GameAction.ConfirmMoveKnightOffTurn, cornerTileNo);
    }
    confirmRemoveKnight(cornerTileNo) {
        this.send(GameAction.ConfirmRemoveKnight, cornerTileNo);
    }
    confirmDiceSelection(confirmDice) {
        this.send(GameAction.ConfirmDicePair, confirmDice);
    }
    cancelAction() {
        this.send(GameAction.CancelAction, true);
    }
    clickedDevelopmentCard(cardEnum) {
        this.send(GameAction.ClickedDevelopmentCard, cardEnum);
    }
    requestSpecialBuildPhase() {
        this.send(GameAction.RequestSpecialBuildPhase, true);
    }
    cancelSpecialBuildPhase() {
        this.send(GameAction.CancelSpecialBuildPhase, true);
    }
    clickedRematch() {
        this.send(GameAction.ClickedRematch, true);
    }
    clickedVote(id, accepted) {
        this.send(GameAction.Vote, {
            id: id,
            accepted: accepted
        });
    }
    requestActionSwap(requestedAction) {
        this.send(GameAction.RequestActionSwap, requestedAction);
    }
    requestHintForBeginner(isUsersFirstGame) {
        this.send(GameAction.RequestBeginnerHint, isUsersFirstGame);
    }
    skipWelcomeActionOnBeginnerMode() {
        this.send(GameAction.SkipWelcomeAction, true);
    }
    endBeginnerModeLevel() {
        this.send(GameAction.RequestBeginnerModeLevelEnd, true);
    }
    togglePause() {
        this.send(GameAction.TogglePause, true);
    }
    leaveGame() {
        this.send(GameAction.LeaveGame, true);
    }
    resign() {
        this.send(GameAction.Resign, true);
    }
    submitChat(text) {
        this.send(GameAction.GameChatSubmit, text);
    }
    reportPlayer(reportReason, playerColor) {
        const dataToSend = {
            reportReason: reportReason,
            reportedPlayerColor: playerColor
        };
        this.send(GameAction.ReportPlayer, dataToSend);
    }
    requestGameState() {
        this.send(GameAction.RequestGameState, this.getServerId());
    }
    pong() {
        this.send(GameAction.Pong, undefined);
    }
    notifyBackendClientAutoReconnected() {
        this.send(GameAction.NotifyBackendClientAutoReconnected, undefined);
    }
    send(action, payload) {
        const data = {
            action: action,
            payload: payload,
            sequence: this.gameActionSendSequence += 1
        };
        this.sender.sendToServer(ClientMessageSubType.GameAction, this.getServerId(), data);
    }
    constructor(sender, getServerId){
        this.gameActionSendSequence = 1;
        this.sender = sender;
        this.getServerId = getServerId // find a better way to access the serverId...
        ;
    }
}
